import { Type } from "@angular/core";
import { ControlNumberComponent } from "../components/number/number.component";
import { ControlSelectComponent } from "../components/select/select.component";
import { ControlStringComponent } from "../components/string/string.component";
import { ControlType } from "../models/form.model";
import { ControlDateComponent } from "../components/date/date.component";
import { ControlSwitchComponent } from "../components/switch/switch.component";
import { ControlRadioComponent } from "../components/radio/radio.component";
import { ControlSelectGroupComponent } from "../components/select/selectGroup.component";

export const ControlTypes = {
  Object: 'object',
  String: 'string',
  Number: 'number',
  Select: 'select',
  SelectGroup: 'selectGroup',
  Date: 'date',
  Switch: 'switch',
  Radio: 'radio',
}

export const CONTROL_TYPES: Record<ControlType, Type<unknown>> = {
  string: ControlStringComponent,
  number: ControlNumberComponent,
  select: ControlSelectComponent,
  selectGroup: ControlSelectGroupComponent,
  date:   ControlDateComponent,
  switch: ControlSwitchComponent,
  radio:  ControlRadioComponent,
};

export const ALLOWED_INPUTS_BY_TYPE: Record<ControlType, string[]> = {
  string: ['maxLength', 'minLength', 'suffix', 'preffix', 'suffixIcon', 'prefixIcon'],
  number: ['min', 'max', 'step', 'suffix'],
  select: ['options', 'isMulti'],
  selectGroup: ['options'],
  date: ['subType'],
  switch: [],
  radio: ['options'],
};
